import SignIn from '/src/pages/SignIn'
import AcceptUserAuthInvitation from '/src/pages/AcceptUserAuthInvitation'
import ResetPassword from '/src/pages/NewResetPassword'
import EditResetPassword from '/src/pages/EditResetPassword'
import UserAuthApp from '../userAuthApp'

export default {
  path: '/user_auths',
  component: UserAuthApp,
  children: [
    {
      path: 'sign_in',
      component: SignIn
    },
    {
      path: 'invitation/accept',
      component: AcceptUserAuthInvitation
    },
    {
      path: 'password/new',
      component: ResetPassword
    },
    {
      path: 'password/edit',
      component: EditResetPassword
    }
  ]
}
